export default __webpack_public_path__ + "static/media/CBR.0812bda6.png";